// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'flatpickr/dist/flatpickr.css';

import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'
import veeNbNo from 'vee-validate/dist/locale/nb_NO'
import 'classlist-polyfill'
import zenscroll from 'zenscroll'
import VueRouter from 'vue-router';

import App from '@/App.vue'
import { router } from '@/router';
import store from '@/store';
import phoneValidation from '@/validations/phone'

console.log('Adding beforeinstallprompt listener')
window.addEventListener('beforeinstallprompt', e => {
  console.log('Received beforeinstallprompt!!!')

  // Prevent Chrome 67 and earlier from automatically showing the prompt
  e.preventDefault()

  store.commit('install/setPrompt', e)
});

if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js', {
            scope: '/',
        }).catch(error => {
            console.warn('Failed to register sw, trying to force update', error);
            navigator.serviceWorker.getRegistration().then(swRegistration => {
                if (!swRegistration) {
                    return;
                }

                swRegistration.update();
            });
        });
    });
}

zenscroll.setup(500, 50)

Validator.localize('nb_NO', veeNbNo);

Validator.extend('phone', phoneValidation);
Validator.localize('nb_NO', {
  messages: {
    phone: (field: string) => `${field}-feltet må være et gyldig telefonnummer`,
  },
});

Vue.config.productionTip = false
Vue.use<any>(VeeValidate, {
  locale: 'nb_NO',
  delay: 500,
  inject: false
})

Vue.use(VueRouter);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<app></app>',
  components: { App },
  router,
  store,
})
